/* jshint esversion: 6 */

import {CourseEvents} from "course/CourseEvents";
import {LearningData} from "common/datapersistence/LearningData";
import {CookieDataReader} from "localstorage/cookie/CookieDataReader";
import {LocalStorageDataReader} from "localstorage/localstorage/LocalStorageDataReader";
import {IndexedDBDataReader} from "localstorage/indexedDB/IndexedDBDataReader";
import {Event} from "common/Event";
import {Core} from "common/Core.js";

export function LocalDataLoader(userID) {
    "use strict";

    const learningData = new LearningData();

    // revealing public api
    return {

        // public api for config

        /**
         * Gets the storage method for the course.
         *
         * @returns {String} "cookies"
         */
        getStorageMethod: function () {
            return "cookies";
        },

        /**
         * Gets current course score.
         *
         * @returns {Number} score
         */
        getScore: learningData.getScore,

        /**
         * Gets current course (lesson) status.
         *
         * @returns {String} lesson status or "unknown"
         */
        getLessonStatus: learningData.getLessonStatus,

        /**
         * Checks the lessons status and location for resuming the course.
         *
         * @returns {Boolean} true or false
         */
        canResume: learningData.canResume,


        // core api

        /**
         * @private
         */
        getLearningData: learningData.getLearningData,

        /**
         * @private
         */
        setLearningData: learningData.setLearningData,

        /**
         * @private
         * @deprecated
         */
        getMasteryScore: learningData.getMasteryScore,

        /**
         * @private
         */
        getLessonLocation: learningData.getLessonLocation,

        /**
         * @private
         */
        setUsername: learningData.setUsername,

        /**
         * @private
         */
        getUsername: function () {
            const userName = learningData.getUsername();
            if (userName) {
                return userName;
            }

            learningData.setUsername("");
            return "";
        },

        /**
         * @private
         */
        getUserID: function () {
            return userID;
        },

        /**
         * @private
         */
        refreshDataBuffer: function () {

            const cookieMap = userID ? CookieDataReader.read(userID) : new Map(),
                storageMap = LocalStorageDataReader.read();
            let merged = Core.mergeMaps(cookieMap, storageMap);

            IndexedDBDataReader.read().then((dbMap) => {
                merged = Core.mergeMaps(merged, dbMap);
                merged.forEach((data, id) => {
                    learningData.setLearningData(id, data);
                });

                Event.trigger(document, CourseEvents.BUFFER_REFRESHED);
            });
        }
    };
}
